import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-violet-100 bg-white/95 shadow-sm backdrop-blur" data-id="element-266" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-1.5 text-center font-display text-[10px] font-bold tracking-wide text-white sm:text-xs md:text-sm" data-id="element-267" data-mp="1y4vex3htaxj6">
        🇦🇷 Sistema N°1 de Movilidad y Flexibilidad en Argentina
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-medium text-slate-500 md:flex" data-id="element-268" data-mp="2qryapnv3su5q">
        <span className="flex items-center gap-1.5" data-id="element-269" data-mp="2lvr4dtyspgn9">
          <ZapIcon className="h-3.5 w-3.5 text-accent" data-id="element-270" data-mp="2h1df89aq85r1" /> Acceso en 5 minutos
        </span>
        <span className="text-violet-300" data-id="element-271" data-mp="2c2k0yenm8apt">·</span>
        <span className="flex items-center gap-1.5" data-id="element-272" data-mp="2c1r01ubc8ffl">
          <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-273" data-mp="39k0rr0bnqcgi" /> Pago seguro
        </span>
        <span className="text-violet-300" data-id="element-274" data-mp="34rz98wnwbpi1">·</span>
        <span className="flex items-center gap-1.5" data-id="element-275" data-mp="34q645lsxldc5">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-276" data-mp="26aji67r6vsm" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}